export default __webpack_public_path__ + "static/media/logo-grad-n.ec94ba13.svg";